import { render, staticRenderFns } from "./Demoted.vue?vue&type=template&id=5ca7839d&scoped=true"
import script from "./Demoted.vue?vue&type=script&lang=js"
export * from "./Demoted.vue?vue&type=script&lang=js"
import style0 from "./Demoted.vue?vue&type=style&index=0&id=5ca7839d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca7839d",
  null
  
)

export default component.exports